import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import Spinner from "../layout/Spinner";

const PrivateRoute = ({ children }) => {
	const { isAuthenticated, loading } = useSelector(
		(state) => state.authReducer
	);
	// if (loading) return <Spinner />;
	return isAuthenticated ? children : <Navigate to='/login' />;
};

export default PrivateRoute;
